var map = {
	"./de/kv.png": "rfNL",
	"./en/kv.png": "hr5S",
	"./es/kv.png": "m4Zn",
	"./fr/kv.png": "sgG2",
	"./ja/kv.png": "MH6Z",
	"./ko/kv.png": "WVJ6",
	"./pt/kv.png": "hkLe",
	"./ru/kv.png": "VjN/",
	"./th/kv.png": "DRMc",
	"./zh-Hant/kv.png": "232g"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "HdSP";